export default "__VITE_ASSET__BAYf4ZAL__"